import React from 'react'
import Delete from './Marketing/Delete'

const NotFound = () => {
  return (
    <div><Delete/></div>
  )
}
export default NotFound